import "core-js/modules/es6.object.freeze";
import { AnyColor } from '../types/color';
import { colors as colorsDefault, colorsRefresh } from './colors';
import { shadows as shadowsDefault, shadowsRefresh } from './shadows';
var backgroundColorMap = {
  "default": AnyColor.Blue,
  tertiary: AnyColor.Light,
  secondary: AnyColor.Blue,
  dark: AnyColor.Dark
};
var borderColorMap = {
  "default": AnyColor.Blue,
  tertiary: AnyColor.Gray3,
  secondary: AnyColor.Blue,
  dark: AnyColor.Dark
};
var colorMap = {
  "default": AnyColor.Dark,
  tertiary: AnyColor.Dark,
  secondary: AnyColor.Light,
  dark: AnyColor.Light
};

var getBackgroundColor = function getBackgroundColor(colors) {
  return function (color) {
    var backgroundColor = backgroundColorMap[color] || backgroundColorMap["default"];
    return colors[backgroundColor];
  };
};

var getBorderColor = function getBorderColor(colors) {
  return function (color) {
    var borderColor = borderColorMap[color] || borderColorMap["default"];
    return colors[borderColor];
  };
};

var getShadow = function getShadow(shadows) {
  return function (_color) {
    return shadows.box.spread;
  };
};

var getTriangleColor = function getTriangleColor(colors) {
  return function (color) {
    if (color === 'tertiary') {
      return colors.white;
    } else {
      return getBorderColor(colors)(color);
    }
  };
};

var getColor = function getColor(colors) {
  return function (color) {
    var highlightColor = colorMap[color] || colorMap["default"];
    return colors[highlightColor];
  };
};

export var popovers = Object.freeze({
  getColor: getColor(colorsDefault),
  getBackgroundColor: getBackgroundColor(colorsDefault),
  getBorderColor: getBorderColor(colorsDefault),
  getTriangleColor: getTriangleColor(colorsDefault),
  getShadow: getShadow(shadowsDefault)
});
export var popoversRefresh = Object.freeze({
  getColor: getColor(colorsRefresh),
  getBackgroundColor: getBackgroundColor(colorsRefresh),
  getBorderColor: getBorderColor(colorsRefresh),
  getTriangleColor: getTriangleColor(colorsRefresh),
  getShadow: getShadow(shadowsRefresh)
});